import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
  path = '';
  pdfFailed = false;

  constructor(private changeDetectorRef: ChangeDetectorRef, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe((params) => {
      const path: string | null = params['path'];

      if (path) {
        this.path = decodeURIComponent(path);
      }
    });
  }

  ngOnInit(): void {
    this.setFullModeContainer();
  }

  onPdfLoadingFailed(): void {
    this.pdfFailed = true;
    this.changeDetectorRef.detectChanges();
  }

  setFullModeContainer(): void {
    (document.querySelector('#loading-animation') as HTMLDivElement).style.display = 'none';

    const toolbar = document.getElementById('main-app-toolbar');
    const sidenavContainer = document.getElementsByClassName('main-app-sidenav-container').item(0) as HTMLElement;

    if (toolbar) {
      toolbar.style.display = 'none';
    }

    if (sidenavContainer) {
      sidenavContainer.style.setProperty('margin-top', '0', 'important');
      sidenavContainer.style.height = '100vh';
    }
  }
}
